import { Root } from './ui/root';
import { Uploader } from './ui/uploader';
import { Thumbnails } from './ui/thumbnails';

export type { MediaItem } from './media.types';
export { convertToMediaFile } from './mappers/convert-to-media-file';
export { useMedia } from './media.context';

export const Media = { Root, Thumbnails, Uploader };
